import { render, staticRenderFns } from "./QuestionnaireIntro.vue?vue&type=template&id=30dd31a0&scoped=true&"
import script from "./QuestionnaireIntro.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireIntro.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireIntro.vue?vue&type=style&index=0&id=30dd31a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd31a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
